import EventCategoryRestrictionItem from './EventCategoryRestrictionItem';

export default EventCategoryRestrictionItem;
